__turbopack_context__.v({
  "card": "style-module-scss-module__b7HjKG__card",
  "description": "style-module-scss-module__b7HjKG__description",
  "form": "style-module-scss-module__b7HjKG__form",
  "image": "style-module-scss-module__b7HjKG__image",
  "input": "style-module-scss-module__b7HjKG__input",
  "inputWrapper": "style-module-scss-module__b7HjKG__inputWrapper",
  "title": "style-module-scss-module__b7HjKG__title",
});
